import {
  AcceptIcon,
  BuildingIcon,
  CaseIcon,
  CircleIcon,
  ClassificationIcon,
  CompanyIcon,
  ComplaintCaseIcon,
  ContactIcon,
  FileIcon,
  InfoIcon,
  InsurancePolicyIcon,
  InsuredCaseIcon,
  RepairCaseIcon,
  TaskIcon,
  UserIcon,
} from '@/shared/icons/Icons';

type Props = {
  type: string
}

const AsyncAutocompleteTypeIcon: React.FC<Props> = ({ type }) => {
  switch (type) {
    case 'Building':
      return <BuildingIcon />;
    case 'CaseClassification':
      return <ClassificationIcon />;
    case 'CentralCompany':
    case 'Company':
      return <CompanyIcon />;
    case 'Contact':
      return <ContactIcon />;
    case 'Contract':
      return <FileIcon />;
    case 'info':
      return <InfoIcon />;
    case 'Policy':
      return <InsurancePolicyIcon />;
    case 'selected':
      return <AcceptIcon />;
    case 'User':
      return <UserIcon />;
    case 'InsuranceClaim':
      return <InsuredCaseIcon />;
    case 'Complaint':
      return <ComplaintCaseIcon />;
    case 'Repair':
      return <RepairCaseIcon />;
    case 'Case':
      return <CaseIcon />;
    case 'Task':
      return <TaskIcon />;
    default:
      return <CircleIcon />;
  }
};

export default AsyncAutocompleteTypeIcon;